export enum DeviceToggleBtnValues {
    Number = 'number',
    Percent = 'percent',
}

export interface FiltersInterface {
    from: string;
    to: string;
    setFrom: (from) => void;
    setTo: (to) => void;
    queryChannelName?: string;
    setQueryChannelName?: (queryChannelName) => void;
    selectedChannelName: string;
    setSelectedChannelName: (selectedChannelName) => void;
    hasViewChannelsAL: boolean;
}

export enum DateDropdownOptions {
    Calendar = 'calendar',
    Last7days = '7',
    Last14days = '14',
    Last30days = '30',
    Last3months = '90',
    Last6months = '180',
    Last12months = '365',
    All = 'all',
}
export interface DateOptionsInterface {
    isBorderBottom?: boolean;
    value: number | string;
    label: string;
}

export enum RadioValues {
    Opened = 'opened',
    Clicked = 'clicked',
    Unsubscribed = 'unsubscribed',
}

export type LegendDataType = {
    name: string;
    icon?: JSX.Element;
}[];

export type PieChartData = {
    name: string;
    value: number;
    percent?: number;
    color?: string;
    label: string;
};

export type PieChartsDataType = {
    pieChartDataOpened: PieChartData[];
    pieChartDataClicked: PieChartData[];
    pieChartDataUnsubscribed: PieChartData[];
};

export interface DeviceDetailsToggleBtnOptInterface {
    label: string;
    value: DeviceToggleBtnValues;
}

export interface ToggleButtonProps {
    setToggleBtnValue: (format: DeviceToggleBtnValues) => void;
}

export interface DetailedRow {
    name?: string;
    opens?: number | string;
    rate?: string;
    opened?: number | string;
    clicked?: number | string;
    unsubscribed?: number | string;
}
